import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { RouterModule } from '@angular/router';

import { MgButtonModule } from '@app/src/app/button';
import { AvatarClusterModule } from '@app/src/app/components/AvatarCluster';
import { MgImageModule } from '@app/src/app/components/MgImage';
import { PointsBannerModule } from '@app/src/app/components/Points/PointsBanner';
import { StreamSwipeStackModule } from '@app/src/app/components/StreamSwipeStack';
import { MgContentLinkModule } from '@app/src/app/content-link';
import { ChallengeResponseLongCardModule } from '@app/src/app/content-views/components/ChallengeResponseLongCard';
import { MgAvatarModule } from '@app/src/app/elements/MgAvatar';
import { MgEllipsisModule } from '@app/src/app/elements/MgEllipsis';
import { MgPersonMinimalModule } from '@app/src/app/elements/MgPersonMinimal';
import { MgIconModule } from '@app/src/app/icon';
import { MgOverlayToolsModule } from '@app/src/app/overlay/tools';
import { PermissionsModule } from '@app/src/app/permissions';
import { MgPipesModule } from '@app/src/app/pipes';
import { UgcLinksContentPipeModule } from '@app/src/app/ugc-links/pipes/UgcLinksContent';

import { LongCardBaseModule } from '../LongCardBase';
import { ChallengeLongCardComponent } from './ChallengeLongCard.component';

@NgModule({
  imports: [
    // Minga dependencies
    MgButtonModule,
    MgAvatarModule,
    MgPersonMinimalModule,
    MgEllipsisModule,
    MgPipesModule,
    LongCardBaseModule,
    MgImageModule,
    UgcLinksContentPipeModule,
    PermissionsModule,
    MgOverlayToolsModule,
    MgIconModule,
    AvatarClusterModule,
    ChallengeResponseLongCardModule,
    StreamSwipeStackModule,
    MgContentLinkModule,
    PointsBannerModule,

    // External dependencies
    CommonModule,
    FlexLayoutModule,
    RouterModule,
  ],
  declarations: [ChallengeLongCardComponent],
  exports: [ChallengeLongCardComponent],
})
export class ChallengeLongCardModule {}
